import { render } from "./image-text-box.html?vue&type=template&id=5986df37"
import script from "./image-text-box.js?vue&type=script&lang=js"
export * from "./image-text-box.js?vue&type=script&lang=js"

import "./image-text-box.less?vue&type=style&index=0&lang=less"

import exportComponent from "/Users/vito.degioia/Documents/Projects/mb-fiori-2023/fiori-del-mulino/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__